import u from "../hooks/graphql/useGetFrontendConfig.js";
import { PRELOAD_KEY as C } from "../../temp-lib/constants/preloadKey.js";
import { RETRY as d } from "../../temp-lib/constants/retry.js";
import { usePreloadContext as p } from "../../temp-lib/contexts/share/PreloadContext.js";
import { createStrictContext as g } from "../../temp-lib/util/context/createStrictContext.js";
import y from "p-retry";
import * as i from "ramda";
import { useState as E, useCallback as f } from "react";
import F from "use-async-effect";
import { jsx as x } from "react/jsx-runtime";
const [N, G] = g("FrontendConfig"), L = (s) => {
  const {
    children: c
  } = s, [o, a] = E(null), {
    preloadValue: n
  } = p(), {
    fetch: e
  } = u(), r = f(async () => y(async () => {
    const t = await n(C.FRONTEND_CONFIG, e);
    if (i.isNil(t))
      throw new Error("frontend config is not loaded yet");
    return t;
  }, d.DEFAULT), [e, n]), m = f(async () => i.isNotNil(o) ? o : r(), [o, r]);
  return F(async (t) => {
    const l = await r().catch(() => null);
    t() && a(l);
  }, []), /* @__PURE__ */ x(N, {
    value: {
      config: o,
      waitConfig: m
    },
    children: c
  });
};
export {
  L as FrontendConfigProvider,
  G as useFrontendConfigContext
};
//# sourceMappingURL=FrontendConfigContext.js.map
